var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeclosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.3335C21.8082 13.8317 22.5 12.5 22.5 12.5C22.5 12.5 18.8636 5.5 12.5 5.5C12.1588 5.5 11.8254 5.52013 11.5 5.55822C11.1578 5.59828 10.8244 5.65822 10.5 5.73552",
    stroke: "#957DAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5C12.8506 9.5 13.1872 9.56015 13.5 9.67071C14.3524 9.97199 15.028 10.6476 15.3293 11.5C15.4398 11.8128 15.5 12.1494 15.5 12.5",
    stroke: "#957DAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5L21.5 21.5",
    stroke: "#957DAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5C12.1494 15.5 11.8128 15.4398 11.5 15.3293C10.6476 15.028 9.97201 14.3524 9.67073 13.5C9.61389 13.3392 9.57037 13.1721 9.5415 13",
    stroke: "#957DAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64701 9.5C4.33877 9.84451 4.06234 10.1824 3.81864 10.5C2.95286 11.6282 2.5 12.5 2.5 12.5C2.5 12.5 6.13636 19.5 12.5 19.5C12.8412 19.5 13.1746 19.4799 13.5 19.4418",
    stroke: "#957DAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclosed);
export default __webpack_public_path__ + "static/media/eyeclosed.959e05cf05041a8c92acdfd380448651.svg";
export { ForwardRef as ReactComponent };